import { createContext } from 'react';
import type { FormType } from './typings';

export const FormTypeContext = createContext<FormType>('form');
FormTypeContext.displayName = 'FormTypeContext';

export const { Provider: FormTypeProvider, Consumer: FormTypeConsumer } = FormTypeContext;
